import React, { Component } from 'react'
import { Alert, Button, OverlayTrigger, Table, Tooltip } from 'react-bootstrap'
import Lightbox from 'react-image-lightbox'
import InputRange from 'react-input-range'
import 'react-input-range/lib/css/index.css'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Select from 'react-select'
import { bindActionCreators } from 'redux'
import { fetchUsersTxInsights } from '../actions'
import { fetchAllBusinesses } from '../actions/businesses_all'
import { closeModalDialog, openModalDialog } from '../actions/modal_dialog'
import {
  disableTransactionSort,
  enableTransactionSort,
  TX_GRID_SORT_ACCESS_CODE,
  TX_GRID_SORT_COUNTRY_CODE,
  TX_GRID_SORT_ORDER_ASC,
  TX_GRID_SORT_ORDER_DESC,
  TX_GRID_SORT_STATUS,
  TX_GRID_SORT_UPDATED,
} from '../actions/tx_grid_sort'
import SimpleModal from '../components/simple_modal'
import CountryFilter from '../components/transaction_grid/country_filter'
import CSVExporterFactory from '../managers/csv_export/csv_exporter_factory'
import SortData from '../models/sort_data'
import { formatTimeString } from '../utils/formatters'
import { getSearchParams } from '../utils/helpers'
import { getImageSrc } from '../utils/images'
import { CustomPagination } from './common/custom_pagination/custom_pagination'
import ErrorMessageTable from './common/error_message_table'
import TransactionNotesTable from './common/transaction_notes'
import CSVExport from './csv_export'
import Spinner3Bounce from './spinner_3_bounce'
import StatusLabel from './status_label'
import BusinessFilter from './transaction_grid/business_filter'
import ErrorFilter from './transaction_grid/error_filter'
import ImageInput from './transaction_grid/image_input'

import PageSizeFilter from './transaction_grid/page_size_filter'
import StatusFilter from './transaction_grid/status_filter'
import { getScore } from './tx_details_components/face_match_score'

const toolTipImage = <Tooltip id='toolTipImage'>Image Types</Tooltip>

const toolTipColumns = <Tooltip id='toolTipColumns'>Columns</Tooltip>

const toolTipImageSearch = <Tooltip id='toolTipColumns'>Find similar</Tooltip>

const styles = {
  imagePreview: {
    height: 80,
    marginRight: 2,
    marginBottom: 2,
    borderRadius: 2,
  },
  minMax: {
    position: 'relative',
    top: 6,
  },
}

const defaultState = {
  faceMatchUpper: 100,
  faceMatchLower: 0,
  faceMatchFilter: false,
  imageTypes: {
    selfie: true,
    front: true,
    back: true,
    passport: true,
  },
  imageTypesData: [
    { label: 'Selfie', value: 'selfie' },
    { label: 'Front', value: 'front' },
    { label: 'Back', value: 'back' },
    { label: 'Passport', value: 'passport' },
  ],
  columns: {
    accessCode: true,
    countryCode: false,
    faceMatch: false,
    phone: false,
    acuant: true,
    errors: false,
  },
  columnsData: [
    { label: 'AccessCode', value: 'accessCode' },
    { label: 'CountryCode', value: 'countryCode' },
    { label: 'FaceMatch', value: 'faceMatch' },
    { label: 'Phone', value: 'phone' },
    { label: 'First Name / Last Name', value: 'name' },
    { label: 'Acuant Result', value: 'acuant' },
    { label: 'Errors', value: 'errors' },
  ],
  tempImageValue: '',
  tempImageChanged: false,
}

class InsightsTable extends Component {
  static csvExportHeader = [
    'Access Code',
    'First Name',
    'Last Name',
    'Country Code',
    'Created',
    'Updated',
    'Status',
    'Is Accredited Investor',
    'Investor Status',
    'Face Match Score',
    'Errors',
  ]

  static csvExportHeader = ['Business Name', 'Status', 'Created', 'AccessCode', 'CountryCode', 'FaceMatch', 'Errors']

  constructor(props) {
    super(props)
    const { fetchUsersTxInsights } = this.props
    this.fetchUsersTxInsights = fetchUsersTxInsights.bind(this)

    const params = getSearchParams()
    params.pageSize = params.pageSize || 5

    this.state = {
      ...defaultState,
      filter: params,
    }
  }

  componentDidMount() {
    const { state, props } = this
    const { filter } = this.state
    const { searchTerm, sortField, sortOrder, fetchAllBusinesses } = props
    const sortData = new SortData(sortField, sortOrder)
    this.refetchUsersTx(
      filter.page,
      filter.status,
      searchTerm,
      sortData,
      null,
      filter.business,
      filter.country,
      null,
      filter.pageSize,
      null,
      filter.error,
      state.faceMatchLower,
      state.faceMatchUpper,
      filter.image
    )
    fetchAllBusinesses()
  }

  refetchUsersTx() {
    this.fetchUsersTxInsights(...arguments)
  }

  openLightbox = (img) => {
    this.setState({
      lightboxImage: img,
    })
  }

  closeLightbox = () => {
    this.setState({
      lightboxImage: null,
    })
  }

  getSortIcon = (field) => {
    const { sortOrder, sortField } = this.props
    let icon = null
    if (sortField && sortField === field) {
      switch (sortOrder) {
        case TX_GRID_SORT_ORDER_ASC:
          icon = <i className='fa fa-sort-amount-asc' />
          break
        case TX_GRID_SORT_ORDER_DESC:
          icon = <i className='fa fa-sort-amount-desc' />
          break
        default:
      }
      if (icon) {
        icon = <div style={{ float: 'right' }}>{icon}</div>
      }
    }
    return icon
  }

  searchString = (filter = {}, page = 1) => {
    const { business, status, country, error, pageSize, image } = filter

    let search = '?page=' + page

    if (country) {
      search = this.addToSearch(search, `country=${country}`)
    }
    if (status) {
      search = this.addToSearch(search, `status=${status}`)
    }
    if (business) {
      search = this.addToSearch(search, `business=${business}`)
    }
    if (error) {
      search = this.addToSearch(search, `error=${error}`)
    }
    if (pageSize) {
      search = this.addToSearch(search, `pageSize=${pageSize}`)
    }
    if (image) {
      search = this.addToSearch(search, `image=${image}`)
    }

    return search
  }

  handleSelectPage = (page, metaKey) => {
    const { props, state } = this
    const { searchTerm, sortField, sortOrder, navigateToPage, navigateToPageInNewWindow } = props
    const { filter, faceMatchLower, faceMatchUpper } = state
    const sortData = sortField ? new SortData(sortField, sortOrder) : null

    if (page === this.getActivePage()) {
      return
    }

    const search = this.searchString(filter, page)
    const { business, status, country, error, pageSize, image } = filter
    if (metaKey) {
      navigateToPageInNewWindow('', search || '')
    } else {
      navigateToPage('', search || '')
      this.refetchUsersTx(
        page,
        status,
        searchTerm,
        sortData,
        null,
        business,
        country,
        null,
        pageSize,
        null,
        error,
        faceMatchLower,
        faceMatchUpper,
        image
      )
    }
  }

  handleTableSort(field) {
    const { searchTerm, sortField, sortOrder, enableTransactionSort, disableTransactionSort } = this.props
    let sortDirection = TX_GRID_SORT_ORDER_ASC
    const page = this.getActivePage()
    if (sortField && sortField === field) {
      switch (sortOrder) {
        case TX_GRID_SORT_ORDER_ASC:
          sortDirection = TX_GRID_SORT_ORDER_DESC
          break
        case TX_GRID_SORT_ORDER_DESC:
          sortDirection = null
          break
        default:
      }
    }
    if (sortDirection) {
      enableTransactionSort(field, sortDirection)
    } else {
      disableTransactionSort()
      field = null
    }
    const sortData = new SortData(field, sortDirection)
    const { business, status, country, error, pageSize, image } = this.state.filter
    this.refetchUsersTx(
      page,
      status,
      searchTerm,
      sortData,
      null,
      business,
      country,
      null,
      pageSize,
      null,
      error,
      null,
      null,
      image
    )
  }

  searchByFacematch = () => {
    const page = this.getActivePage()
    const { business, status, country, error, pageSize, image } = this.state.filter
    const { searchTerm, sortField, sortOrder } = this.props
    const sortData = sortField ? new SortData(sortField, sortOrder) : null
    this.refetchUsersTx(
      page,
      status,
      searchTerm,
      sortData,
      null,
      business,
      country,
      null,
      pageSize,
      null,
      error,
      this.state.faceMatchLower,
      this.state.faceMatchUpper,
      image
    )
  }

  addToSearch = (search = '', term) => {
    if (search === '') {
      search += '?'
    } else {
      search += '&'
    }
    return search + term
  }

  updateFilter = (event) => {
    const { props, state } = this
    const { navigateToPage } = props
    const { faceMatchLower, faceMatchUpper } = state
    const filter = { ...state.filter, ...event }
    this.setState({ filter })
    const { business, status, country, error, pageSize, image } = filter

    const search = this.searchString(filter)
    navigateToPage('', search || '')
    this.refetchUsersTx(
      1,
      status,
      null,
      null,
      null,
      business,
      country,
      null,
      pageSize,
      null,
      error,
      faceMatchLower,
      faceMatchUpper,
      image
    )
  }

  changeColumn = (column, show) => {
    let columns = this.state.columns
    columns[column] = show
    this.setState({
      columns,
    })
  }

  changeImage = (imageType, show) => {
    let imageTypes = this.state.imageTypes
    imageTypes[imageType] = show
    this.setState({
      imageTypes,
    })
  }

  getActivePage() {
    const { location } = this.props
    if (location.search.indexOf('page=') !== -1) {
      return parseInt(location.search.split('page=').pop(), 0)
    }
    return 1
  }

  handleChange = (newValue, actionMeta) => {
    switch (actionMeta.action) {
      case 'select-option':
        this.changeColumn(actionMeta.option.value, true)
        break
      case 'remove-value':
        this.changeColumn(actionMeta.removedValue.value, false)
        break
      case 'clear':
        let columns = this.state.columns
        columns.accessCode = false
        columns.countryCode = false
        columns.errors = false
        columns.faceMatch = false
        columns.phone = false
        columns.acuant = false
        columns.name = false
        this.setState({
          columns,
        })
        break
      default:
    }
  }

  handleImageChange = (newValue, actionMeta) => {
    switch (actionMeta.action) {
      case 'select-option':
        this.changeImage(actionMeta.option.value, true)
        break
      case 'remove-value':
        this.changeImage(actionMeta.removedValue.value, false)
        break
      case 'clear':
        let imageTypes = this.state.imageTypes
        imageTypes.selfie = false
        imageTypes.front = false
        imageTypes.back = false
        imageTypes.passport = false
        this.setState({
          imageTypes,
        })
        break
      default:
    }
  }

  resetFilters = () => {
    this.refetchUsersTx(null, null, null, null, null, null, null, null, 5, null, null, null, null, null)
    this.props.history.push({ pathname: '/insights', search: null })
    this.setState({
      filter: {
        business: null,
        status: null,
        error: null,
        country: null,
        pageSize: 5,
        image: null,
      },
    })
  }

  handleImageInputChange = (event) => {
    this.setState({
      tempImageValue: event.target.value,
      tempImageChanged: true,
    })
  }

  handleImageSubmit = (event) => {
    event.preventDefault()
    this.setState({
      filter: {
        business: null,
        status: null,
        error: null,
        country: null,
        pageSize: 5,
        image: this.state.tempImageValue,
      },
    })
    let search = ''
    if (this.state.tempImageValue) {
      search = this.addToSearch(search, `image=${this.state.tempImageValue}`)
    }
    this.props.history.push({ pathname: '/insights', search: search || null })
    this.refetchUsersTx(
      1,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      this.state.filter.pageSize,
      null,
      null,
      null,
      null,
      this.state.tempImageValue
    )
  }

  openModalDialog(content, type) {
    let modalContent, modalTitle

    if (type === 'notes') {
      modalContent = <TransactionNotesTable data={content} />
      modalTitle = 'Notes'
    }
    if (type === 'reasons') {
      modalContent = ErrorMessageTable.renderTable(content)
      modalTitle = 'On Hold / Decline Reasons'
    }
    const { openModalDialog } = this.props
    this.setState({
      modalContent,
      modalTitle,
    })
    openModalDialog()
  }

  render() {
    const { state, props, updateFilter } = this
    const { userTxs, errorMessage, requestUrl, count, closeModalDialog, isModalDialogOpen } = props
    const { columns } = state
    const activePage = this.getActivePage()

    if (userTxs === null) {
      return (
        <div className='text-center grid-spinner-mt-240'>
          <Spinner3Bounce isActive />
        </div>
      )
    }

    const processedUserTxs = this.props.userTxs

    return (
      <div className='ibox float-e-margins animated fadeIn'>
        <div className='ibox-title'>
          <div className='row'>
            <div className='col-xs-6 col-sm-2'>
              <BusinessFilter updateFilter={updateFilter} filter={state.filter.business} />
            </div>
            <div className='col-xs-6 col-sm-2'>
              <StatusFilter updateFilter={updateFilter} filter={state.filter.status} />
            </div>
            <div className='col-xs-6 col-sm-2'>
              <ErrorFilter updateFilter={updateFilter} filter={state.filter.error} />
            </div>
            <div className='col-xs-6 col-sm-2'>
              <CountryFilter updateFilter={(event) => updateFilter({ country: event })} filter={state.filter.country} />
            </div>
            <div className='col-xs-6 col-sm-2'>
              <PageSizeFilter updateFilter={updateFilter} filter={parseInt(state.filter.pageSize, 10)} />
            </div>
            <div className='col-xs-6 col-sm-2'>
              <CSVExport
                exporter={CSVExporterFactory.INSIGHTS}
                header={InsightsTable.csvExportHeader}
                count={count}
                url={requestUrl}
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-xs-6 col-sm-6'>
              <OverlayTrigger placement='top' overlay={toolTipColumns}>
                <div className='form-group'>
                  <Select
                    defaultValue={[state.columnsData[0]]}
                    placeholder='Columns'
                    onChange={this.handleChange}
                    onInputChange={this.handleInputChange}
                    isMulti
                    name='columns'
                    options={state.columnsData}
                    className='basic-multi-select'
                    classNamePrefix='select'
                  />
                </div>
              </OverlayTrigger>
            </div>
            <div className='col-xs-6 col-sm-6'>
              <OverlayTrigger placement='top' overlay={toolTipImage}>
                <div>
                  <Select
                    defaultValue={[...state.imageTypesData]}
                    placeholder='Image Types'
                    onChange={this.handleImageChange}
                    isMulti
                    name='images'
                    options={state.imageTypesData}
                    className='basic-multi-select'
                    classNamePrefix='select'
                  />
                </div>
              </OverlayTrigger>
            </div>
            <div className='col-xs-6 col-sm-2' />
          </div>
          <div className='row'>
            <div
              className='col-xs-6 col-sm-6'
              style={{ display: 'flex', justifyContent: 'space-between', alignContent: 'center' }}
            >
              <InputRange
                maxValue={100}
                minValue={0}
                value={{
                  min: state.faceMatchLower,
                  max: state.faceMatchUpper,
                }}
                onChange={(value) =>
                  this.setState({
                    faceMatchLower: value.min,
                    faceMatchUpper: value.max,
                  })
                }
              />
              <Button
                variant='primary'
                className={'m-l-5'}
                onClick={this.searchByFacematch}
                style={{ minWidth: 175, marginLeft: 5 }}
              >
                Search By Facematch
              </Button>
            </div>
            <div className='col-xs-6 col-sm-4'>
              <ImageInput
                value={state.tempImageChanged ? state.tempImageValue : state.filter.image || ''}
                handleFieldChange={this.handleImageInputChange}
                handleImageSubmit={this.handleImageSubmit}
              />
            </div>
            <div className='col-xs-6 col-sm-2'>
              <div className='col-xs-6 col-sm-2' />
              <Button onClick={this.resetFilters} variant={'default'}>
                Reset Filters
              </Button>
            </div>
          </div>
        </div>
        <div className='ibox-content'>
          <div>
            {errorMessage && <Alert variant='danger'>{errorMessage}</Alert>}
            <div className='table-responsive'>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th className='cursor-pointer'>Images</th>
                    {columns.countryCode && (
                      <th className='cursor-pointer' onClick={() => this.handleTableSort(TX_GRID_SORT_COUNTRY_CODE)}>
                        CC
                      </th>
                    )}
                    <th className='cursor-pointer' onClick={() => this.handleTableSort(TX_GRID_SORT_STATUS)}>
                      Status
                    </th>
                    <th className='cursor-pointer td-nowrap' onClick={() => this.handleTableSort(TX_GRID_SORT_UPDATED)}>
                      Dates
                    </th>
                    {columns.accessCode && (
                      <th
                        className='cursor-pointer td-nowrap'
                        onClick={() => this.handleTableSort(TX_GRID_SORT_ACCESS_CODE)}
                      >
                        <div>
                          <div style={{ float: 'left' }}>Access Code</div>
                          {this.getSortIcon(TX_GRID_SORT_ACCESS_CODE)}
                        </div>
                      </th>
                    )}
                    {columns.faceMatch && (
                      <th className='cursor-pointer td-nowrap'>
                        <div style={{ float: 'left' }}>FaceMatch</div>
                      </th>
                    )}
                    {columns.phone && (
                      <th className='cursor-pointer td-nowrap'>
                        <div style={{ float: 'left' }}>Phone</div>
                      </th>
                    )}
                    {columns.name && (
                      <th className='cursor-pointer td-nowrap'>
                        <div style={{ float: 'left' }}>First Name / Last Name</div>
                      </th>
                    )}
                    {columns.acuant && (
                      <th className='cursor-pointer td-nowrap'>
                        <div style={{ float: 'left' }}>Acuant Result</div>
                      </th>
                    )}
                    {columns.errors && (
                      <th className='cursor-pointer td-nowrap'>
                        <div style={{ float: 'left' }}>Errors</div>
                      </th>
                    )}
                    <th />
                  </tr>
                </thead>
                <tbody>
                  {processedUserTxs.map((tx) =>
                    tx.transaction_identity ? (
                      <tr key={tx.id} className='cursor-pointer' title={`View Transaction ID: ${tx.id}`}>
                        <td style={{ position: 'relative' }} title=''>
                          {tx.transaction_identity.identity_documents.map((doc) => {
                            if (
                              state.imageTypes.front &&
                              doc.document_type === 'front' &&
                              doc.is_active &&
                              doc.state !== 'disabled'
                            ) {
                              return (
                                <img
                                  key={doc.id}
                                  onClick={() => this.openLightbox(doc.document)}
                                  alt=''
                                  style={styles.imagePreview}
                                  src={getImageSrc(doc)}
                                />
                              )
                            }
                            if (
                              state.imageTypes.back &&
                              doc.document_type === 'back' &&
                              doc.is_active &&
                              doc.state !== 'disabled'
                            ) {
                              return (
                                <img
                                  key={doc.id}
                                  onClick={() => this.openLightbox(doc.document)}
                                  alt=''
                                  style={styles.imagePreview}
                                  src={getImageSrc(doc)}
                                />
                              )
                            }
                            if (
                              state.imageTypes.selfie &&
                              doc.document_type === 'selfie' &&
                              doc.is_active &&
                              doc.state !== 'disabled'
                            ) {
                              return (
                                <img
                                  key={doc.id}
                                  onClick={() => this.openLightbox(doc.document)}
                                  alt=''
                                  style={styles.imagePreview}
                                  src={getImageSrc(doc)}
                                />
                              )
                            }
                            if (
                              state.imageTypes.passport &&
                              doc.document_type === 'passport' &&
                              doc.is_active &&
                              doc.state !== 'disabled'
                            ) {
                              return (
                                <img
                                  key={doc.id}
                                  onClick={() => this.openLightbox(doc.document)}
                                  alt=''
                                  style={styles.imagePreview}
                                  src={getImageSrc(doc)}
                                />
                              )
                            }
                            return null
                          })}
                          <a href={`/insights?page=1&image=${tx.id}`} target='_blank' rel='noreferrer'>
                            <OverlayTrigger placement='top' overlay={toolTipImageSearch}>
                              <i className='fa fa-search' style={{ position: 'absolute', top: 13, right: 20 }} />
                            </OverlayTrigger>
                          </a>
                        </td>
                        {columns.countryCode && (
                          <td onClick={() => props.viewTxDetails(tx.id)}>{tx.transaction_identity.country_code}</td>
                        )}
                        <td onClick={() => props.viewTxDetails(tx.id)}>
                          <StatusLabel state={tx.state} holdReason={tx.hold_reason} />
                        </td>
                        <td onClick={() => props.viewTxDetails(tx.id)}>
                          <div>
                            {formatTimeString(tx.created, 'YYYY-MM-DD HH:MM')}
                            <br />
                            {formatTimeString(tx.updated, 'YYYY-MM-DD HH:MM')}
                          </div>
                        </td>
                        {columns.accessCode && (
                          <td onClick={() => props.viewTxDetails(tx.id)}>{tx.transaction_identity.client_guid}</td>
                        )}
                        {columns.faceMatch && (
                          <td onClick={() => props.viewTxDetails(tx.id)}>{tx.transaction_metadata.face_match_score}</td>
                        )}
                        {columns.phone && (
                          <td onClick={() => props.viewTxDetails(tx.id)}>
                            {tx.transaction_identity.identity_phone_numbers.map((phone) => (
                              <div key={phone.phone_number}>{phone.phone_number}</div>
                            ))}
                          </td>
                        )}
                        {columns.name && (
                          <td onClick={() => props.viewTxDetails(tx.id)}>
                            {tx.transaction_identity.first_name} {tx.transaction_identity.last_name}
                          </td>
                        )}
                        {columns.acuant && (
                          <td onClick={() => props.viewTxDetails(tx.id)}>
                            <span
                              className='label label-success text-uppercase'
                              style={{ cursor: 'default', fontSize: '14px' }}
                            >
                              {getScore(tx.transaction_identity.identity_data_sources) || 'N/A'}
                            </span>
                          </td>
                        )}
                        {columns.errors && (
                          <td onClick={() => props.viewTxDetails(tx.id)}>
                            {tx.transaction_identity.errors.map((error, index) => (
                              <div key={index}>{error.error_code.error_code_name}</div>
                            ))}
                          </td>
                        )}
                        <td>
                          {tx.transaction_notes.length > 0 && (
                            <button
                              className='btn btn-sm btn-default'
                              type='button'
                              onClick={() => this.openModalDialog(tx.transaction_notes, 'notes')}
                            >
                              Notes
                            </button>
                          )}
                          <br />
                          {ErrorMessageTable.getErrors(tx).length > 0 && (
                            <button
                              className='btn btn-sm btn-default'
                              type='button'
                              onClick={() => this.openModalDialog(ErrorMessageTable.getErrors(tx), 'reasons')}
                            >
                              On Hold / Decline Reasons
                            </button>
                          )}
                        </td>
                      </tr>
                    ) : (
                      <tr key={tx.id}>
                        <td>-</td>
                        <td>-</td>
                        {columns.countryCode && <td>-</td>}
                        <td>-</td>
                        {columns.accessCode && <td>-</td>}
                        {columns.faceMatch && <td>-</td>}
                        {columns.phone && <td>-</td>}
                        {columns.name && <td>-</td>}
                        {columns.acuant && <td>-</td>}
                        {columns.errors && <td>-</td>}
                        <td>-</td>
                      </tr>
                    )
                  )}
                </tbody>
              </Table>
            </div>
            {state.lightboxImage && <Lightbox mainSrc={state.lightboxImage} onCloseRequest={this.closeLightbox} />}

            <div className='text-center'>
              <CustomPagination
                activePage={activePage}
                onPageChanged={this.handleSelectPage}
                totalRecords={this.props.count}
                pageLimit={state.filter.pageSize}
              />
            </div>
          </div>
        </div>

        <SimpleModal
          isModalDialogOpen={isModalDialogOpen}
          content={state.modalContent}
          title={state.modalTitle}
          close={closeModalDialog}
        />
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  errorMessage: state.tx.errorMessage,
  userTxs: state.tx.userTxs,
  isFetching: state.tx.isFetching,
  count: state.tx.count,
  requestUrl: state.tx.requestUrl,
  nextUrl: state.tx.nextUrl,
  searchTerm: state.transactionSearch.searchTerm,
  pageHash: ownProps.location.hash,
  sortField: state.txGridSort.sortField,
  sortOrder: state.txGridSort.order,
  businesses: state.businessesAll.businesses,
  isModalDialogOpen: state.modalDialog.isModalDialogOpen,
})

const mapDispatchToProps = (dispatch, ownProps) =>
  bindActionCreators(
    {
      fetchAllBusinesses,
      fetchUsersTxInsights,
      enableTransactionSort,
      disableTransactionSort,
      viewTxDetails: (id) => window.open(`/tx-details/${id}`, '_blank').focus(),
      viewTxVisualization: () => ownProps.history.push('/tx-visualization'),
      viewLandingPage: () => ownProps.history.push('/landing-page'),
      navigateToPage: (p, s) => ownProps.history.push({ pathname: '/insights', search: s || '' }),
      navigateToPageInNewWindow: (p, s) => {
        window.open(`/insights${s}`, '_blank')
      },
      openModalDialog,
      closeModalDialog,
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(InsightsTable))
